module.exports = __webpack_public_path__ + "img/U1F3C8.9f0e5200.png";